export const verificationStatuses = {
  PENDING: 'PENDING',
  PROVISIONAL: 'PROVISIONAL',
  ACCEPTED: 'ACCEPTED',
  REVIEW: 'REVIEW',
  UNVERIFIED: 'UNVERIFIED',
  REJECTED: 'REJECTED',
}
